module.exports = "<div id=\"js-pjax-loader-bar\" class=\"pjax-loader-bar\">\n    <div class=\"progress\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./example/app/common/loadingbar/loadingbar.html
// module id = 274
// module chunks = 40